"use strict";
import Vue from 'vue';
import axios from "axios";
import serveIN from "./interface.js";
import store from '@/store'
import Router from '@/router'
import Message from './message.js';
import qs from 'qs'
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.post['Content-Type'] = 'application/json';

let config = {
  //baseURL: "http://192.168.1.234:9030",
  //  headers: {'Access-Control-Allow-Origin': '*','Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}
  // timeout: 10, // Timeout?
  //                                                                                                     
};
const _axios = axios.create(config);
_axios.interceptors.request.use(
  function (config) {
    // if (!config.headers.token) {
    //   if (localStorage.getItem("SET_TOKEN")) { // 判断是否存在token，如果存在的话，则每个http header都加上token
    //     config.headers.token = localStorage.getItem("SET_TOKEN");
    //     config.headers.version = '1.0.0' ;
    //   }
    // }
    // if(config.url=='/v2/api/eseal-usermanage/activation/user'){
    //   config.headers.token = '';
    // }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);


function toLogin(response) {
  var loginError = [51000,51001, 51002, 51003];
  if (response.status == 200 && loginError.includes(response.data.code)) {
    Router.push({
			name: 'login'
		  })
  }
}
_axios.defaults.sendSuscced = true;  // 初始化报错后的请求状态
_axios.defaults.retryDelay = 1000; // 设置间隔时间
_axios.defaults.timeout = 60*1000; // 设置超时时间
_axios.defaults.retry = 4;
_axios.interceptors.response.use(function(response){
  /*对响应数据做些事*/
  // toLogin(response);
  return response;
}, function(error){
  /*请求错误时做些事*/

  if(error.code == 'ECONNABORTED' && error.message.indexOf('timeout')!=-1){
    var config = error.config;
    config.__retryCount = config.__retryCount || 0;
    if(config.__retryCount >= config.retry) {
      // Reject with the error
      //window.location.reload();
      Message({
          message:'请求超时',
          type: "warning"
        });

      return Promise.reject(error);
    }

    // Increase the retry count
    config.__retryCount += 1;
    // Create new promise to handle exponential backoff
    var backoff = new Promise(function(resolve) {
      setTimeout(function() {
        resolve();
      }, config.retryDelay || 1);
    });

    return backoff.then(function() {
      return _axios(config);
    });
  }else{

    return Promise.reject(error);

  }
});
const myPlugin ={
  install(Vue, options){
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
      axios: {
        get() {
          return _axios;
        }
      },
      $axios: {
        get() {
          return _axios;
        }
      },
    });
  }
}
Vue.use(myPlugin)
export default myPlugin;